import './styles/global.scss';
import React, { useState, useEffect } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab, faTwitter } from '@fortawesome/free-brands-svg-icons';
import {
  Route,
  Routes,
} from 'react-router-dom';
import Login from './pages/login';
import Admin from './pages/admin';
import Industry from './pages/industry';
import OutreachUnsubscribe from './pages/outreach-unsubscribe';
import UpdateBanner from './components/UpdateBanner';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';


function App() {
  library.add(fab, faTwitter);

  const [showUpdateBanner, setShowUpdateBanner] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState(null);

  useEffect(() => {
    serviceWorkerRegistration.register({
      onUpdate: (registration, worker) => {
        setWaitingWorker(worker);
        setShowUpdateBanner(true);
      },
      onSuccess: () => {
        console.log('Service worker registered successfully');
      },
    });
  }, []);

  const handleUpdate = () => {
    if (waitingWorker) {
      waitingWorker.postMessage({ type: 'SKIP_WAITING' });
      waitingWorker.addEventListener('statechange', (e) => {
        if (e.target.state === 'activated') {
          window.location.reload();
        }
      });
      // Fallback: if skipWaiting already happened (top-level in SW), just reload
      setTimeout(() => window.location.reload(), 500);
    } else {
      // No waiting worker — SW already activated, just reload
      window.location.reload();
    }
  };

  const handleDismiss = () => {
    setShowUpdateBanner(false);
  };

  return (

    <div className="App">
      {showUpdateBanner && (
        <UpdateBanner onUpdate={handleUpdate} onDismiss={handleDismiss} />
      )}
      <Routes>
        <Route path="/outreach/unsubscribe" element={<OutreachUnsubscribe />} />
        <Route path="/industry/*" element={<Industry />} />
        <Route path="/admin/*" element={<Admin />} />
        {/* Commented out to work on Industry, Comment in when finished <Route path="/*" element={<Login />} /> */}
        <Route path="/*" element={<Login />} />

      </Routes>
    </div>
  );
}
export default App;
